import React from 'react';

import ControlsRewind from '@videoblocks/react-icons/ControlsRewind';

interface AudioPlayerRewindButtonProps {
  iconClassName?: string;
  // eslint-disable-next-line @typescript-eslint/ban-types
  onClick: Function;
}

const AudioPlayerRewindButton = ({
  iconClassName,
  onClick,
}: AudioPlayerRewindButtonProps): JSX.Element => {
  return (
    <ControlsRewind
      className={`fill-current ${iconClassName}`}
      onClick={onClick}
    />
  );
};

export default AudioPlayerRewindButton;
